










































import {Component, Vue, Watch} from 'vue-property-decorator';
import {scroller} from 'vue-scrollto/src/scrollTo';

export enum Dollars {
  ONE = "one",
  FIVE = "five",
  TEN = "ten",
  MORE = "more"
}

@Component({
  components: {}
})
export default class Donate extends Vue {

  private amount: number = 1;
  private oneDollar: Dollars | null = Dollars.ONE;
  private fiveDollar: Dollars | null = null;
  private tenDollar: Dollars | null = null;
  private moreDollar: Dollars | null = null;
  private moreDollarAmount: number = 0;

  docScroll(id: string): void{
    const firstScrollTo = scroller();
    firstScrollTo(`#${id}`);
  }

  get oneDollarClass(){
    return this.oneDollar? 'active' : '';
  }
  get fiveDollarClass(){
    return this.fiveDollar? 'active' : '';
  }
  get tenDollarClass(){
    return this.tenDollar? 'active' : '';
  }
  get moreDollarClass(){
    return this.moreDollar? 'active' : '';
  }

  changeOneDollarAmount(){
    this.amount = 1;
    this.oneDollar = Dollars.ONE;
    this.fiveDollar = null;
    this.tenDollar = null;
    this.moreDollar = null;
    this.mountpaypalbutton(this.amount);
  }
  changeFiveDollarAmount() {
    this.amount = 5;
    this.oneDollar = null;
    this.fiveDollar = Dollars.FIVE;
    this.tenDollar = null;
    this.moreDollar = null;
    this.mountpaypalbutton(this.amount);
  }
  changeTenDollarAmount() {
    this.amount = 10;
    this.oneDollar = null;

    this.fiveDollar = null;
    this.tenDollar = Dollars.TEN;
    this.moreDollar = null;
    this.mountpaypalbutton(this.amount);
  }
  changeMoreDollarAmount(){
    this.oneDollar = null;
    this.fiveDollar = null;
    this.tenDollar = null;
    this.moreDollar = Dollars.MORE;
    this.mountpaypalbutton(this.moreDollarAmount);
  }

  @Watch('moreDollarAmount')
  onChangeMoreAmount(amount: number){
    this.moreDollarAmount = amount;
    this.mountpaypalbutton(amount);
  }
  mounted(){
    this.mountpaypalbutton(1);
  }

  mountpaypalbutton(amount: number){
    let buttons = document.getElementById("paypal-button-container");
    if(buttons && buttons.childNodes.length > 0) {
      buttons.removeChild(buttons.childNodes[0]);
    }
    if(amount > 0){

        window.paypal
            .Buttons({
              createOrder:async function(data:any, actions:any) {
                  return actions.order.create({
                    purchase_units: [
                      {
                        amount: {
                          value: amount,
                        },
                      },
                    ],
                  });
              },
              onApprove: async function(data:any, actions:any) {
                  return actions.order.capture();
              },
              onShippingChange: async function(data:any, actions:any) {
                  // if (data.shipping_address.country_code !== 'US') {
                  //   return actions.reject();
                  // }
                  return actions.resolve();

              },
              onError: async function (err: any){
                  console.error(err);
                  window.location.href = "/error";
              },
              style: {
                shape: "rect",
                color: "blue",
                layout: "vertical",
                label: "paypal",
                size: "medium"
              },
            }).render("#paypal-button-container");
      }
    }
};
